const Fonts = [
  {'id': '---Sans---', 'disabled':true},
  {'id': 'Anton'},
  {'id': 'Archivo Narrow'},
  {'id': 'Dosis'},
  {'id': 'Karla'},
  {'id': 'Quattrocento Sans'},
  {'id': 'Rubik Mono One'},
  {'id': 'Roboto Condensed'},
  {'id': 'Roboto'},
  {'id': 'Source Sans Pro'},
  {'id': '---Serif---', 'disabled':true},
  {'id': 'Bree Serif'},
  {'id': 'Merriweather'},
  {'id': 'Source Serif Pro'},
  {'id': 'Roboto Slab'},
  {'id': 'Quattrocento'},
  {'id': 'Sanchez',},
  {'id': '---Script---', 'disabled':true},
  {'id': 'Abril Fatface'},
  {'id': 'Bevan'},
  {'id': 'Boogaloo'},
  {'id': 'Bungee Shade'},
  {'id': 'Caveat'},
  {'id': 'Faster One'},
  {'id': 'Gochi Hand'},
  {'id': 'Kaushan Script'},
  {'id': 'Knewave'},
  {'id': 'Lilita One'},
  {'id': 'Megrim'},
  {'id': 'Pacifico'},
  {'id': 'Passion One'},
  {'id': 'Patrick Hand'},
  {'id': 'Permanent Marker'},
  {'id': 'Rancho'},
  {'id': 'Ranga'},
  {'id': 'Vast Shadow'},
]
export default Fonts;


// WEBPACK FOOTER //
// ./src/data/Fonts.js